import { Truck, PackageCheck, Store, Search } from "lucide-react";
import { Link } from "react-router-dom";
import React from "react";

export function Omnichannel() {
  return (
    <section
      id="omnichannel"
      className="relative bg-surface/50 border-y border-border py-12 overflow-hidden"
    >
      <div className="neon-orb w-[400px] h-[400px] bg-neon-cyan/15 top-10 -left-40" />
      <div className="container relative mx-auto px-4 lg:px-8">
        <div className="text-center max-w-2xl mx-auto mb-8">
          <p className="text-sm uppercase tracking-widest text-primary font-semibold mb-2">
            Omnichannel
          </p>
          <h2 className="text-2xl sm:text-4xl font-display font-bold">
            Choose How You{" "}
            <span className="text-gradient-brand">Receive It</span>
          </h2>
          <p className="mt-3 text-sm text-muted-foreground">
            Three flexible ways to get your tech — built for life across Kenya.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          <Card
            icon={Truck}
            title="1-Day Delivery"
            desc="Order before 2 PM and we'll deliver across Nairobi the next day. Free on orders over KES 5,000."
            accent="cyan"
          />
          <Card
            icon={PackageCheck}
            title="Countryside Shipping"
            desc="Secure tracked shipping to all 47 counties in 2–5 working days via our courier partners."
            accent="purple"
          />
          <div className="rounded-2xl glass-card p-5 hover:border-primary/40 transition-colors">
            <div className="w-10 h-10 rounded-xl bg-gradient-brand/15 border border-accent/30 flex items-center justify-center mb-3">
              <Store className="h-5 w-5 text-accent" />
            </div>
            <h3 className="text-lg font-display font-bold">Store Pickup</h3>
            <p className="mt-1.5 text-sm text-muted-foreground leading-relaxed">
              Reserve online, collect in-store within 2 hours from any of 30+
              locations.
            </p>
            <div className="flex flex-wrap gap-2.5 pt-3">
              <Link
                to="/store-locator/"
                className="inline-flex items-center justify-center rounded-xl bg-primary px-4 py-2.5 text-xs sm:text-sm font-semibold text-white shadow-lg shadow-primary/25 transition-all hover:bg-primary/90"
              >
                Find a Store Near You
              </Link>
              <Link
                to="/contact/"
                className="inline-flex items-center justify-center rounded-xl border border-white/20 bg-white/10 px-4 py-2.5 text-xs sm:text-sm font-semibold text-white backdrop-blur-md transition-all hover:bg-white/20"
              >
                Contact Support
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function Card({
  icon: Icon,
  title,
  desc,
  accent,
}: {
  icon: typeof Truck;
  title: string;
  desc: string;
  accent: "cyan" | "purple";
}) {
  return (
    <div className="rounded-2xl glass-card p-5 hover:border-primary/40 transition-colors">
      <div
        className={`w-10 h-10 rounded-xl border flex items-center justify-center mb-3 ${
          accent === "cyan"
            ? "bg-neon-cyan/10 border-neon-cyan/30"
            : "bg-neon-purple/10 border-neon-purple/30"
        }`}
      >
        <Icon
          className={`h-5 w-5 ${accent === "cyan" ? "text-neon-cyan" : "text-neon-purple"}`}
        />
      </div>
      <h3 className="text-lg font-display font-bold">{title}</h3>
      <p className="mt-1.5 text-sm text-muted-foreground leading-relaxed">
        {desc}
      </p>
    </div>
  );
}
